import React from 'react';
import { Provider, ErrorBoundary } from '@rollbar/react';
import { detectPlatform } from '../utils/utils';

export default function RollbarProviderWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const rollbarConfigSite = {
    accessToken:
      process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_ROLLBAR_TOKEN
        : '',
    environment: 'jgarant.kz',
  };

  const rollbarConfigWebViewBank = {
    accessToken: 'b637c9a7a50845bfb6a5ed0eda695295',
    environment:
      process.env.NODE_ENV === 'production' ? 'production' : 'development',
  };

  const platform = detectPlatform(window.location);

  // Выбираем конфиг по платформе
  const rollbarConfig =
    platform === 'JusanBankView' ? rollbarConfigWebViewBank : rollbarConfigSite;

  return (
    <Provider config={rollbarConfig}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </Provider>
  );
}
